import PackageClaim from '@/models/PackageClaim';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const usePackageClaimsStore = defineStore('packageClaims', {
  state: () => ({}),

  getters: {
    models: () => useRepo(PackageClaim),
  },
});
